





































import { Component, Mixins, Prop, Vue } from "vue-property-decorator";
import { ITaxTemplate } from "@/models/tax";
import TaxTemplateProvider from "@/components/app/global/tax/templates/taxTemplateProvider.vue";
import AddEditTaxTemplateForm from "@/components/app/global/tax/templates/addEditTaxTemplateForm.vue";

@Component({
  components: {
    TaxTemplateProvider,
    AddEditTaxTemplateForm
  }
})
export default class AddEditTaxTemplateModal extends Mixins(Vue) {
  // Refs
  public declare $refs: {
    taxTemplateProvider: TaxTemplateProvider;
    form: AddEditTaxTemplateForm;
  };

  @Prop({ default: undefined })
  public readonly taxTemplateId!: ITaxTemplate["id"];

  public async validateBeforeSubmit() {
    this.$refs.form.validateBeforeSubmit();
  }
}
